<ng-container *transloco="let t; read: 'companies'">
  <kendo-grid
    [data]="company.employees"
    (edit)="editHandler($event)"
    (remove)="removeHandler($event)"
    (add)="addHandler($event)">


    <!-- Desktop grid starts here -->
    <ng-template kendoGridToolbarTemplate>
      <a kendoGridAddCommand class="addIcon">
        <span class="icon">
          <img src="../../../assets/icons/add-icon.svg">
        </span>
        {{t('add')}}
      </a>
    </ng-template>

    <kendo-grid-column field="firstName" title="{{t('firstName')}}" media="(min-width: 993px)"> </kendo-grid-column>

    <kendo-grid-column field="lastName" title="{{t('lastName')}}" media="(min-width: 993px)"> </kendo-grid-column>

    <kendo-grid-column field="email" title="{{t('email')}}" media="(min-width: 993px)"> </kendo-grid-column>

    <kendo-grid-column field="phoneNumber" title="{{t('phoneNumber')}}" media="(min-width: 993px)"> </kendo-grid-column>

    <kendo-grid-column field="language" title="{{t('language')}}" media="(min-width: 993px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{t('languages.' + languages[dataItem.language])}}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="role" title="{{t('role')}}" media="(min-width: 993px)"> </kendo-grid-column>

    <kendo-grid-command-column media="(min-width: 993px)">
      <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
        <a kendoGridEditCommand [attr.tooltip]="t('edit')" flow="up" class="actionIcon"><img src="../../../assets/icons/edit-icon.svg"></a>
        <ng-container>
          <a (click)="open(dataItem)" [attr.tooltip]="t('resetPasswordTitle')" flow="up" class="actionIcon"><img src="../../../assets/icons/reset-pw-icon.svg"></a>
        </ng-container>
        <a kendoGridRemoveCommand flow="up" [attr.tooltip]="t('delete')" class="actionIcon"><img src="../../../assets/icons/delete-icon.svg"></a>
        <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
          {{ isNew ? "Hinzufügen" : "Speichern" }}
        </button>
        <button kendoGridCancelCommand>
          {{ isNew ? "Verwerfen" : "Abbrechen" }}
        </button>

        <!-- password reset dialog -->
        @if (opened) {
          <kendo-dialog
            title="{{t('resetPasswordTitle')}}"
            (close)="close('cancel')"
            [minWidth]="250"
            [width]="450">
            <form [formGroup]="passwordForm">
              <kendo-formfield>
                <kendo-label [for]="newPassword" [text]="t('newPassword')"></kendo-label>
                <input
                  kendoTextBox
                  type="password"
                  class="mbs"
                  formControlName="newPassword"
                  #newPassword
                  required>
                  @if (passwordForm.get('newPassword').hasError('required')) {
                    <kendo-formerror>{{t('isRequired')}}</kendo-formerror>
                  }
                  @if (passwordForm.get('newPassword').hasError('minlength')) {
                    <kendo-formerror>{{t('minLenghtError')}}</kendo-formerror>
                  }
                </kendo-formfield>
                <kendo-formfield>
                  <kendo-label [for]="confirmNewPassword" [text]="t('confirmNewPassword')"></kendo-label>
                  <input
                    kendoTextBox
                    type="password"
                    class="mbs"
                    formControlName="confirmNewPassword"
                    #confirmNewPassword
                    required
                    >
                    @if (passwordForm.get('confirmNewPassword').hasError('required')) {
                      <kendo-formerror>{{t('isRequired')}}</kendo-formerror>
                    }
                  </kendo-formfield>
                  @if (passwordMatchError) {
                    <kendo-formerror>{{t('passwordMatchError')}}</kendo-formerror>
                  }
                  <kendo-dialog-actions>
                    <button
                      [disabled]="passwordForm.invalid"
                      type="submit"
                      kendoButton
                      (click)="submitPasswordChange()"
                      class="buttonPrimary">
                      {{t('changePassword')}}
                    </button>
                    <button
                      kendoButton
                      (click)="close('no')"
                      class="buttonSecondary">
                      Abbrechen
                    </button>
                  </kendo-dialog-actions>
                </form>
              </kendo-dialog>
            }
          </ng-template>
        </kendo-grid-command-column>
        <ng-template kendoGridDetailTemplate let-dataItem>
          <app-company-employee-roles
            [employee]="dataItem"
            [company]="company"
            >
          </app-company-employee-roles>
        </ng-template>
        <!-- Desktop grid starts here -->


        <!-- Mobile grid starts here -->
        <kendo-grid-column-group media="(max-width: 992px)">

          <kendo-grid-column>
            <ng-template kendoGridCellTemplate let-dataItem>
              <h4 class="mobileGridHeader">{{t('firstName')}}</h4>
              <span>{{dataItem.firstName}}</span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column>
            <ng-template kendoGridCellTemplate let-dataItem>
              <h4 class="mobileGridHeader">{{t('lastName')}}</h4>
              <span>{{dataItem.lastName}}</span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column>
            <ng-template kendoGridCellTemplate let-dataItem>
              <h4 class="mobileGridHeader">{{t('email')}}</h4>
              <span>{{dataItem.email}}</span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column>
            <ng-template kendoGridCellTemplate let-dataItem>
              <h4 class="mobileGridHeader">{{t('phoneNumber')}}</h4>
              <span>{{dataItem.phoneNumber}}</span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column>
            <ng-template kendoGridCellTemplate let-dataItem>
              <h4 class="mobileGridHeader">{{t('language')}}</h4>
              <span>{{t('languages.' + languages[dataItem.language])}}</span>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
              {{t('languages.' + languages[dataItem.language])}}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column>
            <ng-template kendoGridCellTemplate let-dataItem>
              <h4 class="mobileGridHeader">{{t('role')}}</h4>
              <span>{{dataItem.role}}</span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-command-column>
            <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
              <a kendoGridEditCommand [attr.tooltip]="t('edit')" flow="up" class="actionIcon"><img src="../../../assets/icons/edit-icon.svg"></a>
              <ng-container>
                <a (click)="open(dataItem)" [attr.tooltip]="t('resetPasswordTitle')" flow="up" class="actionIcon"><img src="../../../assets/icons/reset-pw-icon.svg"></a>
              </ng-container>
              <a kendoGridRemoveCommand flow="up" [attr.tooltip]="t('delete')" class="actionIcon"><img src="../../../assets/icons/delete-icon.svg"></a>
              <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
                {{ isNew ? "Hinzufügen" : "Speichern" }}
              </button>
              <button kendoGridCancelCommand>
                {{ isNew ? "Verwerfen" : "Abbrechen" }}
              </button>

              <!-- password reset dialog -->
              @if (opened) {
                <kendo-dialog
                  title="{{t('resetPasswordTitle')}}"
                  (close)="close('cancel')"
                  [minWidth]="250"
                  [width]="450">
                  <form [formGroup]="passwordForm">
                    <kendo-formfield>
                      <kendo-label [for]="newPassword" [text]="t('newPassword')"></kendo-label>
                      <input
                        kendoTextBox
                        type="password"
                        class="mbs"
                        formControlName="newPassword"
                        #newPassword
                        required>
                      </kendo-formfield>
                      <kendo-formfield>
                        <kendo-label [for]="confirmNewPassword" [text]="t('confirmNewPassword')"></kendo-label>
                        <input
                          kendoTextBox
                          type="password"
                          class="mbs"
                          formControlName="confirmNewPassword"
                          #confirmNewPassword
                          required
                          >
                        </kendo-formfield>
                        <kendo-dialog-actions>
                          <button
                            [disabled]="passwordForm.invalid"
                            type="submit"
                            kendoButton
                            (click)="submitPasswordChange()"
                            class="buttonPrimary">
                            {{t('changePassword')}}
                          </button>
                          <button
                            kendoButton
                            (click)="close('no')"
                            class="buttonSecondary">
                            Abbrechen
                          </button>
                        </kendo-dialog-actions>
                      </form>
                    </kendo-dialog>
                  }
                </ng-template>
              </kendo-grid-command-column>
            </kendo-grid-column-group>
            <!-- Mobile grid ends here -->


          </kendo-grid>

          <app-company-employee-edit
            [model]="editDataItem"
            [isNew]="isNew"
            (save)="saveHandler($event)"
            (cancel)="cancelHandler()"
            >
          </app-company-employee-edit>
        </ng-container>
